import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService, ITypeCategoryAlarmBO, ITypeAlarmBO, ITypeCriquiteAlarmBO, IUserAlarmBO } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AlarmsService {

  className = 'AlarmsService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  //User identity is included on the HTTP token
  getUserNotifications(): Observable<IUserAlarmBO[]> {
    return this.http.get<IUserAlarmBO[]>(environment.base_URL_GAIA + "/users/alarms")
  }

  archiveAlarm(alarm: IUserAlarmBO, id: number, store: any) {
    return this.http.put(environment.base_URL + `/user-alarms/${id}`, alarm, { params: { store: store } })
  }

  getAlarmCriticalityTypes(cache = true, cacheKey = "alarmCritTypes"): Observable<ITypeCriquiteAlarmBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeCriquiteAlarmBO[]>;
    } else {
      const observable = this.http.get<ITypeCriquiteAlarmBO[]>(environment.base_URL_GAIA + "/critique_alarm_types").pipe(map((res: ITypeCriquiteAlarmBO[]) => {
      const active = res.filter(it => it.mrkActive);
      this.cacheService.updateCacheData(active, cacheKey)
      return active;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  addAlarm(alarm: IUserAlarmBO) {
    return this.http.post(environment.base_URL_GAIA + "/user_alarm", alarm)
  }


  /**
   *  Admin alarm
   */

  getAllAlarms(): Observable<ITypeAlarmBO[]> {
    return this.http.get<ITypeAlarmBO[]>(environment.base_URL_GAIA + "/alarm_types")
  }

  newAlarm(alarm: ITypeAlarmBO) {
    return this.http.post(environment.base_URL + "/alarm-type", alarm)
  }

  updateAlarm(alarm: ITypeAlarmBO, id: number) {
    return this.http.put(environment.base_URL + `/alarm-type/${id}`, alarm)
  }


  /**
   * Alarm category types
   */

  getAlarmCategories(cache = true, cacheKey = "alarmCategories"): Observable<ITypeCategoryAlarmBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeCategoryAlarmBO[]>;
    } else {
      const observable = this.http.get<ITypeCategoryAlarmBO[]>(environment.base_URL + "/alarm-type-categories").pipe(map((res: ITypeCategoryAlarmBO[]) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

}
